/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('HistoryCtrl', ['$scope', '$http', 'NetworkService', 'MainService', function ($scope, $http, NetworkService, MainService) {

        $scope.history = []
        var email = MainService.getEmail()
        NetworkService.getHistory(email, function (data) {
            $scope.history = data
        })

        $scope.renderStatus = function (status)
        {
            var statusStr = "-1"

            if (status == 1)
            {
                statusStr = "bestätigt"
            } else if (status == 2)
            {
                statusStr = "Admin hat user eingetragen"
            }
            else if (status == 0)
            {
                statusStr = "User hat sich eingetragen"
            }else if (status == -1)
            {
                statusStr = "Admin hat user abgeleht"
            }
            else if (status == -2)
            {
                statusStr = "Admin hat User von Schicht entfernt"
            }
            else if (status == -3)
            {
                statusStr = "User hat Vorschlag von Admin abgelehnt"
            }
            else if (status == 3)
            {
                statusStr = "User hat Vorschlag von Admin angenommen"
            }else if (status == 4)
            {
                statusStr = "Admin hat user verschoben"
            }
            
            return statusStr;
        }
    }])